import React, { useState, useCallback } from "react";
import { useSelector } from "react-redux";
import Fuse from 'fuse.js';

import { Tooltip } from "primereact/tooltip";

import { TextInputField, DropDownField, AutoCompleteField}  from "../../../helpers";
import { gstCalculation } from "../../../utils";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";


const Product = (props)=>{
    let { sellerData, transactionDetails, handleOnDeleteProduct,  product, error, index, handleProductChange, pettyCashCategories ,UOMData} = props

    const [categorySuggestions, setCategorySuggestions] = useState([])
    const [uomSuggestions, setUomSuggestions] = useState([])
    
    const usersData = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)

    const gstCalculatedValues = gstCalculation(product)
    let isSellerAndPMStateEqual = sellerData?.stateId === transactionDetails?.PMState
    
    let gstRates = pmCompanyConfig.GSTRates
    let gstValues = []
    gstRates.map(eachGSTRate => gstValues.push({label: eachGSTRate.toString(), value: eachGSTRate}))

    const TDSData = [
        { label: "No TDS | 0%", value: 0 },
        { label: "194Q | 0.1%", value: 0.1 },
        { label: "194J | 10%", value: 10 },
        { label: "194C | 1%", value: 1 }
    ]

    const categoryFuzzSearch = useCallback(new Fuse(pettyCashCategories, {
        keys: ['pettyCashCategoryName'],
        includeScore: true,
        threshold: 0.2,
        ignoreLocation: true,
        shouldSort: true,
        getFn: (obj) => {
            return obj.pettyCashCategoryName.replace(/\s+/g, '')
        },
    }), [pettyCashCategories])

    const categorySearchMethod = (event) => {
        if (event.query === "") {
            setCategorySuggestions([...pettyCashCategories])
        }
        else {
            const searchResults = categoryFuzzSearch.search(event.query)
            const relatedCategories = searchResults.map(eachProduct => eachProduct.item)
            setCategorySuggestions(relatedCategories)
        }
    }

    const uomFuzzSearch = useCallback(new Fuse(UOMData, {
        keys: ['UOM'],
        includeScore: true,
        threshold: 0.5,
        ignoreLocation: true,
        shouldSort: true,
        getFn: (obj) => {
            return obj.UOM.replace(/\s+/g, '')
        },
    }), [UOMData])

    const uomSearchMethod = (event) => {
        if (event.query === "") {
            setUomSuggestions([...UOMData])
        }
        else {
            const searchResults = uomFuzzSearch.search(event.query)
            const relatedUom = searchResults.map(eachProduct => eachProduct.item)
            setUomSuggestions(relatedUom)
        }
    }

    const onDeleteClick =() => {
        handleOnDeleteProduct(product.id)
    }

    const handleChange = async (e) => {
        handleProductChange(product.id, e.target.name, e.target.value)
    }

    const isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed

    const docTypeLabels = {
        reqno: "Req No",
        buyerpono: "Buyer PO No",
        sellerpono: "Seller PO No",
        sellerpino: "Seller PI No",
        vpno: "VP No",
        buyerinvoiceno: "Buyer Invoice No"
    }
    
    return(
        <>
            <div className="">
                <h5 className="mb-1"> Product : {props.index+1} &nbsp;&nbsp;<icon className="pi pi-times" style={{color:"red", cursor: "pointer"}} onClick={onDeleteClick}></icon></h5>
            </div>
            <div className="p-card">
                <div>
                    <div className="grid">
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0 post-req-autocomplete">
                            <AutoCompleteField dropdown name="pettyCashCategoryId" labelText="Nature Of Expenses" value={product.pettyCashCategoryId} field="pettyCashCategoryName"  ClassName="styled-autocomplete-dropdown-button" searchMethod={categorySearchMethod} suggestions={categorySuggestions} onChange={handleChange} errorMessage={error[`[${index}].pettyCashCategoryId`]} forceSelection required />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                            <TextInputField name="prodDesc"  labelText='Description' value={product.prodDesc} errorMessage={error[`[${index}].prodDesc`]} onChange={handleChange} required/>
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 post-req-autocomplete">
                            <AutoCompleteField dropdown name="unit" labelText="UOM" value={product.unit} field="UOM"  ClassName="styled-autocomplete-dropdown-button" searchMethod={uomSearchMethod} suggestions={uomSuggestions} onChange={handleChange} errorMessage={error[`[${index}].unit`]} forceSelection required />
                        </div>
                        {
                            isHSNEntryAllowed ? 
                            <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                                <TextInputField name="HSNCode"  labelText='HSN' value={product.HSNCode} inputStyle={{width: "115px"}}  errorMessage={error[`[${index}].HSNCode`]} onChange={handleChange} required/>
                            </div>
                            :
                            null
                        }
                        {
                            pmCompanyConfig.isTDSAutomated ?
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0 ml-4">
                                <DropDownField name="TDS"  labelText='Select TDS' options={TDSData} errorMessage={error[`[${index}].TDS`]} panelStyle={{width: "203px"}} optionLabel="label" optionValue="value" value={product.TDS} onChange={handleChange}/>
                            </div>
                            :
                            <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0 unit-price">
                                <TextInputField name="TDS"  labelText='TDS' value={product.TDS} keyfilter={"pint"} errorMessage={error[`[${index}].TDS`]} onChange={handleChange} />
                            </div>
                        }
                        <div className={`flex flex-column col-12 mb-2 lg:col-2 lg:mb-0`}>
                            <TextInputField
                                name="docNo"
                                labelText={
                                    product?.pettyCashCategoryId?.docType
                                        ? docTypeLabels[product.pettyCashCategoryId.docType.toLowerCase()] || product.pettyCashCategoryId.docType
                                        : "Doc No"
                                }
                                keyfilter="pnum"
                                value={product.docNo}
                                onChange={handleChange}
                                errorMessage={error[`[${index}].docNo`]}
                                required={product?.pettyCashCategoryId?.isDocNoMandatory}
                            />
                        </div>

                    </div>
                    <div className="grid petty-cash-product">
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 unit-price">
                            <TextInputField name="unitPrice"  labelText='Unit Price' value={product.unitPrice} errorMessage={error[`[${index}].unitPrice`]} onChange={handleChange} required/>
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0">
                            <TextInputField name="quantity"  labelText='Quantity' value={product.quantity} errorMessage={error[`[${index}].quantity`]} onChange={handleChange} required/>
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 w-5rem">
                            <DropDownField name="CGST"  labelText='CGST' disabled={product.disabled || !isSellerAndPMStateEqual} options={gstValues} optionLabel="label" optionValue="value" value={product?.CGST}  onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 cgst-value">
                            <TextInputField name="cgstValue"  labelText='CGST Value' disabled value={gstCalculatedValues.cgstValue} onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 w-5rem">
                            <DropDownField name="SGST"  labelText='SGST' options={gstValues} disabled={product.disabled || !isSellerAndPMStateEqual} optionLabel="label" optionValue="value" value={product?.SGST}  onChange={handleChange}/>
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 sgst-value">
                            <TextInputField name="sgstValue"  labelText='SGST Value' value={gstCalculatedValues.sgstValue} disabled onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 w-5rem">
                            <DropDownField name="IGST" keyfilter={"pnum"} labelText='IGST' disabled={product?.disabled || isSellerAndPMStateEqual} options={gstValues}  optionLabel="label" optionValue="value" value={product.IGST} onChange={handleChange}/>
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-1 lg:mb-0 igst-value">
                            <TextInputField name="igst"  labelText='IGST Value' value={gstCalculatedValues.igstValue} disabled onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0">
                            <TextInputField name="taxBeforePrice"  labelText='Before Tax'  value={gstCalculatedValues.taxBeforePrice} disabled onChange={handleChange} />
                        </div>
                        <div className="flex flex-column col-12 mb-2 lg:col-2 lg:mb-0 total-price">
                            <TextInputField name="totalPrice"  labelText='Total Price' value={gstCalculatedValues.totalPrice} disabled onChange={handleChange} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Product;